namespace GeniuzPOS.SalePromoCamp {
    export class LookupItemCodeColumns {
        static columnsKey = 'SalePromoCamp.LookupItemCode';
    }
}
